import * as React from 'react';
import { Banner, Capabilities, Features, Technologies, Testimonials, Companies } from '../components';

const Home = () => (
  <>
    <Banner />
    <Capabilities />
    <Features />
    <Testimonials />
    <Companies />
    <Technologies />
  </>
);

export default Home;
